import { z } from 'zod'

import { OrganizationMemberType } from '../constants/organizationMember'
import { PermissionType } from '../constants/permission'
import { dbEntitySchema } from './system'

export const organizationMemberSchema = dbEntitySchema.extend({
  firstName: z.string().optional().nullable(),
  lastName: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  email: z.string().email().optional().nullable(),
  profileImage: z.string().optional().nullable(),
  organization: z.string(),
  managementUser: z.string(),
  venues: z.array(z.string()).optional().nullable(),
  owner: z.boolean().nullish(),
  title: z.string().optional().nullable(),
  type: z
    .nativeEnum(OrganizationMemberType)
    .default(OrganizationMemberType.STAFF),
  sendAddedNotification: z.boolean().nullish(),
  importId: z.string().optional().nullable(),
  importVenue: z.string().optional().nullable(),
})

export const organizationMemberDetailSchema = organizationMemberSchema.extend({
  emailVerifiedAt: z.coerce.date().nullish(),
})

export const organizationMemberCreateArgsSchema = z.object({
  organizationId: z.string(),
  email: z.string().email(),
  firstName: z.string().optional().nullable(),
  lastName: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  profileImage: z.string().optional().nullable(),
  owner: z.boolean().optional(),
  venueIds: z.array(z.string()).optional(),
  importId: z.string().optional().nullable(),
  importVenue: z.string().optional().nullable(),
})

export const organizationMemberUpdateByIdArgsSchema = z.object({
  firstName: z.string().optional().nullable(),
  lastName: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  profileImage: z.string().optional().nullable(),
  owner: z.boolean().optional(),
  type: z.nativeEnum(OrganizationMemberType).optional(),
})

export const organizationMemberTransferOwnershipArgsSchema = z.object({
  organizationId: z.string(),
  memberId: z.string(),
  actorManagementUserId: z.string(),
  actorIsAdmin: z.boolean().optional(),
})

export const organizationMemberListArgsSchema = z.object({
  organizationId: z.string().optional(),
  managementUserId: z.string().optional(),
  venueId: z.union([z.string(), z.array(z.string())]).optional(),
  type: z
    .union([
      z.nativeEnum(OrganizationMemberType),
      z.array(z.nativeEnum(OrganizationMemberType)),
    ])
    .optional(),
  search: z.string().optional(),
  permissions: z.array(z.nativeEnum(PermissionType)).optional(),
  excludeAdmins: z.boolean().optional(),
  deleted: z.boolean().optional(),
})

export const organizationMemberPermissionOptionsSchema = z.object({
  venueId: z.string().optional(),
  trackActivityLog: z.boolean().optional(),
  managementUserId: z.string().optional(),
})
